var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmptyStatePlaceHolder',{attrs:{"header":"","description":_vm.$t('InsuranceAPI.EmptyPages.PAGE_UNDER_CONSTRUCTION_DESC')}})
}
var staticRenderFns = []

export { render, staticRenderFns }